module.exports = __webpack_public_path__ + "static/media/map-filled.bcb404ea.svg";